import React from 'react'
import { Button, Collapse, Card, CardBody } from 'reactstrap'

export default class PopularLocations extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            collapse: false
        }
    }

    toggle = (e) => {
        e.preventDefault();
        this.setState({ collapse: !this.state.collapse })
    }

    locationList = list => {
        return  list.map((l, idx) => {
            return (
                <div key={l.key} className={'mb-2'}>
                    <a href={l.href}>{l.name}</a>
                    <div className='pull-right d-inline-block' style={{fontSize: '1.5rem', lineHeight: 1}}>&rsaquo;</div>
                </div>
            )
        })
    }

    render() {
        return (
            <div style={{ position: 'relative' }}>
                <a href="#" className="text-nowrap" onClick={this.toggle}>
                    {this.props.toggle_text}
                </a>
                <Collapse isOpen={this.state.collapse} style={{position: 'absolute', zIndex: 999, width: 600}} className="mb-3 mt-2">
                    <Card>
                        <CardBody className="text-left">
                            <div className="row">
                                <div className="col-5">
                                    <h6 className='ml-5 mb-3'>{this.props.top_cities_text}</h6>
                                    {this.locationList(this.props.cities)}
                                </div>
                                <div className="col-7">
                                    <h6 className='ml-5 mb-3'>{this.props.top_airports_text}</h6>
                                    {this.locationList(this.props.airports)}
                                </div>
                                <div className="col"></div>
                            </div>
                        </CardBody>
                    </Card>
                </Collapse>
            </div>
        )
    }
}